import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * يمنع خطأً في صفحة واحدة من تبييض التطبيق كله.
 *
 * أخطاء Convex ترتفع كاستثناءات أثناء العرض؛ بلا حاجز كهذا كانت
 * صفحة واحدة ترفض الوصول فتختفي الواجهة بأكملها.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;

    const denied = String(this.state.error).includes("منسق المشاريع");

    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="w-full max-w-md rounded-2xl border bg-card p-6 text-center shadow-sm">
          <AlertTriangle className="mx-auto mb-3 h-9 w-9 text-amber-500" />
          <h1 className="mb-1 text-base font-bold">
            {denied ? "لا تملك صلاحية هذه الصفحة" : "حدث خطأ غير متوقع"}
          </h1>
          <p className="mb-4 text-xs text-muted-foreground">
            {denied
              ? "هذه الصفحة لمنسق المشاريع الإلكترونية فقط"
              : String(this.state.error).slice(0, 200)}
          </p>
          <Button onClick={() => window.location.assign("/")} className="h-9">
            <RotateCcw className="ml-1.5 h-4 w-4" />
            العودة للصفحة الرئيسية
          </Button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
